// this file is @generated

export enum ConnectorProduct {
  Dispatch = "Dispatch",
  Stream = "Stream",
}

export const ConnectorProductSerializer = {
  _fromJsonObject(object: any): ConnectorProduct {
    return object;
  },

  _toJsonObject(self: ConnectorProduct): any {
    return self;
  },
};
